/** Evento compartido: matriz histórica → exportación y tabla de consulta del hub BNT. */

export const VISOR_HUB_PERIOD_EVENT = "visor:hub-period-select";

/**
 * @param {{ year: number, mes?: number | null, fechaDesde: string, fechaHasta: string, label?: string }} detail
 */
export function dispatchHubPeriodSelect(detail) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(VISOR_HUB_PERIOD_EVENT, { detail }));
}
